<!-- eslint-disable -->
<template>
  <v-card height="100%">
    <v-card-text>
      <v-form @submit.prevent="getAll">
        <v-row>
          <v-col>
            <v-text-field
              dense
              outlined
              type="date"
              label="Fecha Inicial"
              v-model="paginado.inicio"
            />
          </v-col>
          <v-col>
            <v-text-field
              dense
              outlined
              type="date"
              label="Fecha Final"
              v-model="paginado.fin"
            />
          </v-col>
          <v-col>
            <v-btn color="info" type="submit" :disabled="loader">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>

      <v-data-table
        dense
        hide-default-footer
        :headers="headers"
        :items="items"
        class="elevation-1"
        :search.sync="search"
        :loading="loader"
        :items-per-page="paginado.perPage"
      >
        <template v-slot:[`item.id`]="{ item }">
          {{ item.id | folio }}
        </template>
        <template v-slot:[`item.fecha`]="{ item }">
          {{ item.fecha | date }}
        </template>
        <template v-slot:[`item.cajas`]="{ item }">
          {{ item.cajas | numero }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            icon
            color="primary"
            v-if="item.facturar"
            @click="facturarEmbarque(item.id)"
            :disabled="loader"
          >
            <v-icon>mdi-cash</v-icon>
          </v-btn>
          <v-btn
            icon
            color="success"
            @click="getEmbarque(item.id)"
            :disabled="loader"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
      </v-data-table>
      <Paginado :loader="loader" :paginado="paginado" />
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "Embarques",
  data: () => ({
    search: undefined
  }),
  computed: {
    ...mapState({
      headers: state => state.Embarques.headers,
      items: state => state.Embarques.collection,
      loader: state => state.Embarques.loader,
      paginado: state => state.Embarques.paginado
    }),
    actual() {
      return this.paginado.currentPage;
    }
  },
  mounted() {
    this.getAll();
  },
  methods: {
    ...mapActions("Embarques", ["getAll", "getEmbarque", "facturarEmbarque"])
  },
  watch: {
    actual() {
      this.getAll();
    }
  }
};
</script>
